<div id="page-wrapper">
    <div class="app-auth">
        <router-outlet></router-outlet>
    </div>
</div>